import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";
import { connect } from "react-redux";
import {
  FormGroup,
  FormControl,
  FormLabel,
  Button,
  Alert,
} from "react-bootstrap";
import circleInfoIcon from "resources/images/circle-info-dark-green.svg";
import { clearLogoutFlag } from "containers/App/actions";
import LoginUpdateNotification from "./LoginUpdateNotification";

const EmailInput = (props) => {
  const {
    loginStep,
    emailAddress,
    emailValidated,
    handleEmailInput,
    rememberMe,
    loadingIdProvider,
    handleRememberMe,
    resetEmailSent,
    showLoginUpdateNotification,
    ssoError,
    errorMessage,
    passwordReset,
    liOnboarding,
    forceLogout,
    userData,
    onClearLogoutFlag,
    showUserVerified,
  } = props;

  const [showSecurityMessage, setShowSecurityMessage] = useState(
    forceLogout || userData
  );

  useEffect(() => {
    onClearLogoutFlag();
    localStorage.removeItem("token");
  }, []);

  const checkEmailValid = () => {
    const emailSplit = emailAddress.split("@");
    if (showSecurityMessage) {
      setShowSecurityMessage(false);
    }
    return (
      typeof emailSplit[0] === "string" &&
      emailSplit[0].length > 0 &&
      typeof emailSplit[1] === "string" &&
      emailSplit[1].length > 0
    );
  };

  const ssoErrorMessage = ssoError ? (
    <div>
      {ssoError.toJS().map((error) => (
        <p>
          {error}
          <br />
          <br />
        </p>
      ))}
    </div>
  ) : null;

  return (
    <div style={{ display: loginStep === 1 ? "" : "none" }}>
      {showLoginUpdateNotification && <LoginUpdateNotification />}
      {showSecurityMessage && (
        <Alert className="warning-alert-yellow">
          <FontAwesome
            name="exclamation-triangle"
            className="warning-alert-icon align-self-start"
          />
          <span className="warning-alert-text">
            For your security, you've been logged out.
          </span>
        </Alert>
      )}
      {showUserVerified && (
        <Alert className="warning-alert-yellow">
          <FontAwesome
            name="exclamation-triangle"
            className="warning-alert-icon align-self-start"
          />
          <span className="warning-alert-text">
            Your email address has been verified. Please login to continue.
          </span>
        </Alert>
      )}
      {resetEmailSent ? (
        <Alert
          variant="success"
          className="p-3"
          style={{
            backgroundColor: "#EAF9FA",
            border: "1px solid #D5F5F6",
            marginBottom: "32px",
          }}
        >
          <div className="d-flex" style={{ color: "#166669" }}>
            <img
              src={circleInfoIcon}
              alt="success"
              className="mr-3 align-self-start"
            />
            If your account exists in our database, we'll email you a reset
            link.
          </div>
        </Alert>
      ) : null}
      <h5 className="mb-4" style={{ color: "#000", fontSize: "28px" }}>
        {liOnboarding
          ? "Log in to connect Criteria to LinkedIn"
          : "Log in to Criteria"}
      </h5>
      <p className="mb-4" style={{ fontSize: "16px" }}>
        Enter your information below
      </p>
      {passwordReset && (
        <div
          style={{
            borderRadius: "3px",
            backgroundColor: "#eaf9fa",
            color: "#1f8e93",
            height: "50px",
            minWidth: "100%",
            marginBottom: "10px",
            textAlign: "left",
            paddingLeft: "7px",
            fontSize: "14px",
          }}
        >
          <FontAwesome name="check-circle" /> Your Criteria password has been
          successfully updated.
        </div>
      )}
      {ssoError && (
        <Alert className="error-messages" variant="danger">
          {ssoErrorMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert className="error-messages" variant="danger">
          {errorMessage}
        </Alert>
      )}

      <FormGroup>
        {emailValidated && !checkEmailValid() && (
          <div
            style={{
              borderRadius: "3px",
              backgroundColor: "#fbe8eb",
              color: "#e11f3b",
              height: "50px",
              width: "100%",
              marginBottom: "10px",
              textAlign: "left",
              paddingLeft: "7px",
              lineHeight: "50px",
              fontSize: "16px",
            }}
          >
            <FontAwesome name="exclamation-triangle" /> Please enter a valid
            email address.
          </div>
        )}
        <FormLabel
          className="font-weight-bold"
          style={{ fontSize: "14px", marginBottom: "2px" }}
        >
          Email Address
        </FormLabel>
        <FormControl
          type="email"
          placeholder="Enter your email here"
          id="emailAddress"
          value={emailAddress}
          onChange={handleEmailInput}
          data-test="email"
          disabled={loginStep !== 1}
          required
        />
      </FormGroup>
      <div
        className="my-4 text-left d-flex align-items-center"
        style={{ fontSize: "14px", gap: "8px" }}
      >
        <input
          type="checkbox"
          checked={rememberMe}
          onChange={handleRememberMe}
        />
        Remember me
      </div>
      <div className="text-center">
        <Button
          type="submit"
          variant="primary"
          size="lg"
          id="submitEmail"
          className="font-weight-bold"
          style={{ width: "100%", fontSize: "14px" }}
          disabled={loadingIdProvider}
        >
          Continue
        </Button>
        <br />
      </div>
    </div>
  );
};

EmailInput.propTypes = {
  emailAddress: PropTypes.string,
  emailValidated: PropTypes.bool,
  handleEmailInput: PropTypes.func,
  rememberMe: PropTypes.bool,
  loadingIdProvider: PropTypes.bool,
  handleRememberMe: PropTypes.func,
  resetEmailSent: PropTypes.bool,
  showLoginUpdateNotification: PropTypes.bool,
  loginStep: PropTypes.number,
  ssoError: PropTypes.object,
  errorMessage: PropTypes.object,
  passwordReset: PropTypes.bool,
  liOnboarding: PropTypes.bool,
  forceLogout: PropTypes.bool,
  userData: PropTypes.object,
  onClearLogoutFlag: PropTypes.func,
  showUserVerified: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  forceLogout: state.get("App").get("forceLogout"),
  userData: state.get("App").get("userData"),
});

const mapDispatchToProps = (dispatch) => ({
  onClearLogoutFlag: () => dispatch(clearLogoutFlag()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailInput);
